import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import des fichiers de traduction
import fr from './translations/fr.json';
import en from './translations/en.json';
import frBlog from './locales/fr/blog.json';
import enBlog from './locales/en/blog.json';

const resources = {
  fr: {
    translation: fr,
    blog: frBlog
  },
  en: {
    translation: en,
    blog: enBlog
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
